<template>
  <div>
    <div class="box box-primary">
      <div class="box-header">
        <h3 class="box-title">{{$t('service.getusers_title[0]')}}</h3>
      </div>
      <div class="box-body">
        <div>
          <b-table :items="items" :fields="fields" class="mt-3" outlined>
            <template slot="action" slot-scope="row">
              <router-link :to="{name:'ServiceHistory', params: { id: row.item.id }}">
                {{$t('service.getusers_title[1]')}}
              </router-link>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import utils from '@/lib/utils'

export default {
  name: "UsersByService",
  data() {
    return {
      fields: [
        { key: 'full_name', label: this.$t('service.getusers_table[0]'), sortable: true, class: 'text-center'},
        { key: 'date_from', label: this.$t('service.getusers_table[1]'), sortable: true, class: 'text-center' },
        { key: 'date_to', label: this.$t('service.getusers_table[2]'), sortable: true, class: 'text-center' },
        { key: 'action', label: this.$t('service.getusers_table[3]'), class: 'text-center' }
      ],
      items:[],
    };
  },
  methods: {
    ...mapActions([
      "GET_USERS_BY_SERVICE"
    ]),
  },

  mounted() {
    const id = parseInt(this.$route.params.id)
    this.GET_USERS_BY_SERVICE({id: id}).then(
      function(res) {
        let result = res.data
        let users = []
        result.forEach(v => {
          let customerFullName = v.customer.lastname + " " + v.customer.firstname
          let dateFrom = utils.formatSqlDate(v.date_from, null, "MMM Do YYYY")
          let dateTo = utils.formatSqlDate(v.date_to, null, "MMM Do YYYY", 'Forever')
          let data = {
            id: v.customer.id,
            full_name: customerFullName,
            date_from: dateFrom,
            date_to: dateTo
          }
          users.push(data)
        })
        this.items = users
      }.bind(this)
    )
  },
  components: {
  }
};
</script>


// WEBPACK FOOTER //
// src/views/Service/UsersByService.vue